import { Component, computed, inject, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import { getFunnelSettings } from '@innogy/become-a-customer/state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { CommonModule } from '@angular/common';

import { CalculateContainerComponent } from '../calculate-container/calculate-container.component';

@Component({
  selector: 'wl-calculate-modal',
  templateUrl: './calculate-modal.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    CommonModule,
    CalculateContainerComponent,
    ModalComponent,
    ModalBodyDirective,
  ],
})
export class CalculateModalComponent {
  private readonly modal = inject(NgbActiveModal);
  private readonly store$ = inject(Store);

  readonly rendering = input<InnogyComponentRendering>();

  readonly modalTitle = computed(() =>
    getFieldValue<string>(this.rendering(), 'ModalAdjustCalculationTitle')
  );

  readonly funnelSettings = this.store$.selectSignal(getFunnelSettings);
  readonly calculateContent = computed(
    () => this.funnelSettings().changeCalculationComponent
  );

  dismissModal() {
    this.modal.dismiss('dismiss');
  }
}
